import { TwitterShareButton } from 'react-share'

export default function TwitterShare({
  url,
  shortDescription,
  children,
}: {
  url: string
  shortDescription: string
  children: React.ReactNode
}): JSX.Element {
  return (
    <TwitterShareButton
      className="share-icon"
      url={url}
      title={shortDescription}
      via="schoolhouse_edu"
      style={{ width: '100%' }}
    >
      {children}
    </TwitterShareButton>
  )
}
